var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-carousel',{attrs:{"id":"carousel-1","interval":4000}},_vm._l((_vm.thumbURLs),function(url){return _c('b-carousel-slide',{key:url,staticClass:"rounded-0",attrs:{"img-src":url,"alt":"Media Thumb"}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }